export default () => ({
    isShowPartialPaymentInformationPopup: false,
    isShowSubscribePopup2: true, // если false - то покажется только на странице товара
});
